import _ from 'lodash'

export default ({ job: { progress } }) => `${_.round(progress, 1)}%`
